import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, usePublicAmendmentDetailDispatch, usePublicAmendmentDetailState } from './public-amendment-detail-context';
import { usePublicClientState, usePublicPortalBasePath } from '../../../../context/public-client-context';
import PublicAmendmentAppService from '../../../../../../application/platform/public/public-amendment-app-service';
import PublicCommitmentAppService from '../../../../../../application/platform/public/public-commitment-app-service';
import PublicLiquidationAppService from '../../../../../../application/platform/public/public-liquidation-app-service';
import PublicPaymentAppService from '../../../../../../application/platform/public/public-payment-app-service';
import PublicTransferAppService from '../../../../../../application/platform/public/public-transfer-app-service';
import PublicAccountReportAppService from '../../../../../../application/platform/public/public-account-report-app-service';
import PublicAttachmentAppService from '../../../../../../application/platform/public/public-attachment-app-service';

export const usePublicAmendmentDetailController = () => {
    const navigate = useNavigate();
    const dispatch = usePublicAmendmentDetailDispatch();
    const state = usePublicAmendmentDetailState();
    const { clientId } = usePublicClientState();
    const basePath = usePublicPortalBasePath();
    const amendmentId = Number(state.amendmentId);

    useEffect(() => {
        if (!clientId) return;
        PublicAmendmentAppService.getById(clientId, amendmentId).then((data) =>
            dispatch({ type: ACTION_TYPES.setAmendment, payload: data })
        );
        loadCommitments();
        loadTransfers();
        loadAccountReports();
        loadAttachments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId, amendmentId]);

    useEffect(() => {
        if (state.selectedCommitment && clientId) {
            loadLiquidations(state.selectedCommitment.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.selectedCommitment?.id, clientId]);

    function loadCommitments() {
        if (!clientId) return;
        PublicCommitmentAppService.list(clientId, amendmentId, { page: 0, pageSize: 200 }).then((r) =>
            dispatch({ type: ACTION_TYPES.setCommitments, payload: r.items })
        );
    }

    function loadLiquidations(commitmentId: number) {
        if (!clientId) return;
        PublicLiquidationAppService.list(clientId, commitmentId, { page: 0, pageSize: 200 }).then((r) =>
            dispatch({ type: ACTION_TYPES.setLiquidations, payload: r.items })
        );
    }

    function loadPayments(liquidationId: number) {
        if (!clientId) return;
        PublicPaymentAppService.list(clientId, liquidationId, { page: 0, pageSize: 200 }).then((r) =>
            dispatch({ type: ACTION_TYPES.setPayments, payload: r.items })
        );
    }

    function loadTransfers() {
        if (!clientId) return;
        PublicTransferAppService.list(clientId, amendmentId, { page: 0, pageSize: 200 }).then((r) =>
            dispatch({ type: ACTION_TYPES.setTransfers, payload: r.items })
        );
    }

    function loadAccountReports() {
        if (!clientId) return;
        PublicAccountReportAppService.list(clientId, amendmentId, { page: 0, pageSize: 200 }).then((r) =>
            dispatch({ type: ACTION_TYPES.setAccountReports, payload: r.items })
        );
    }

    function loadAttachments() {
        if (!clientId) return;
        PublicAttachmentAppService.list(clientId, 'Amendment', amendmentId).then((data) =>
            dispatch({ type: ACTION_TYPES.setAttachments, payload: data })
        );
    }

    function handleTabChange(_: any, newValue: number) {
        dispatch({ type: ACTION_TYPES.setTabIndex, payload: newValue });
    }

    function handleSelectCommitment(commitment: any) {
        dispatch({ type: ACTION_TYPES.setSelectedCommitment, payload: commitment });
    }

    async function handleDownloadAttachment(id: number, fileName: string) {
        if (!clientId) return;
        const blob = await PublicAttachmentAppService.download(clientId, id);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    }

    function navigateToList() { navigate(`${basePath}/emendas`); }

    return {
        navigateToList, handleTabChange, handleSelectCommitment, loadPayments, handleDownloadAttachment,
    };
};
